import { AWS_API_URL } from 'global/environment';
import { authorize, getRequest } from 'utils/http';

export async function getBookingHistory({ from, to, resourceType } = {}) {
  const query = new URLSearchParams({
    ...(from && { from }),
    ...(to && { to }),
    ...(resourceType && { resourceType }),
  }).toString();

  const url = `${AWS_API_URL}/booking-history${query ? `?${query}` : ''}`;

  return getRequest(url, await authorize());
}
